import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["paymentOptionType", "paymentOptionsList"]

  connect(){
    this.updateGeographicFilter()
    this.updateSelect()
  }

   chooseItem(e) {
    // Make sure a payment option is chosen
    if(this.paymentOptionTypeTarget.value == '') {
      return;
    }

    let paymentRow = {
      payment_option: { type: this.paymentOptionTypeTarget.value, index: this.paymentOptionsListTarget.childElementCount },
      payment_option_owner: e.target.dataset.paymentOptionOwner,
      payment_option_owner_id: e.target.dataset.paymentOptionOwnerId
    }

    new Request.Rails(null, {
      url: e.target.dataset.link,
      method: 'post',
      data: paymentRow,
      onSuccess: response=> {
        let html = Elements.from(response)
        html.inject(this.paymentOptionsListTarget)
        ExtendDOM.runAll(this.paymentOptionsListTarget)
        this.updateSelect()
        this.updateGeographicFilter()

      },
      onFailure: response=>{
        console.log('Fail: ' + response)
      }
    }).send()
  }


  removePaymentOption(e) {
    e.preventDefault()
    let paymentOption = e.target.getParent('li')
    paymentOption.getElement('input[name$="[_destroy]"]').value = 1
    paymentOption.hide()
    paymentOption.getParent('ul').grab(paymentOption)
    this.updateSelect()
  }

  toggleSettings(e) {
    e.preventDefault()
    let currentItem = e.target.getParent('.payment-option-item')
    let currentSetting = currentItem.querySelector('.payment-option-settings')
    let currentSettingSummary = currentItem.querySelector('.payment-option-summary')
    let delete_text = currentItem.querySelector('.link_delete')
    delete_text.style.display = "none"
    currentSetting.classList.toggle('hidden')
    currentSettingSummary.classList.toggle('hidden')
  }

  updateSelect() {
    let addedItems = []
    this.paymentOptionTypeTarget.classList.remove("error");
    this.paymentOptionsListTarget.querySelectorAll('li.payment-option-list-item').forEach((addedItem)=> {
      if (addedItem.querySelector('input.payment-option-item-destroy').value == "false") {
        Array.push(addedItems, addedItem.querySelector('input.payment-option-item-type').value)
      }
    })

    let availableItems = this.paymentOptionTypeTarget.options
    for (let option of availableItems) {
      if (!this.uniqueArray(addedItems).includes(option.value)) {
        this.paymentOptionTypeTarget.selectedIndex = option.index
        let event = document.createEvent('event')
        event.initEvent('change', true, false)
        option.dispatchEvent(event)
        break
      }
    }
  }

  updateGeographicFilter() {
    Array.from(this.paymentOptionsListTarget.querySelectorAll('.payment-option-item')).forEach((currentItem)=> {
      let geographicFilter = currentItem.querySelector('select:not([multiple=multiple])')
      let countrySelects = {}
      Array.from(currentItem.querySelectorAll('select[multiple=multiple]')).map((select)=> {
        countrySelects[select.dataset.name.camelCase()] = currentItem.querySelector(`.${select.dataset.ssid}`)
      })

      if(geographicFilter.value == 'always_show') {
        countrySelects.exclude_from.set('disabled', 'disabled')
        countrySelects.exclude_from.hide()
        countrySelects.include_in.set('disabled', 'disabled')
        countrySelects.include_in.hide()
      } else if(geographicFilter.value == 'include_in') {
        countrySelects.exclude_from.set('disabled', 'disabled')
        countrySelects.exclude_from.hide()
        countrySelects.include_in.removeProperty('disabled')
        countrySelects.include_in.show()
      } else if(geographicFilter.value == 'exclude_from') {
        countrySelects.include_in.set('disabled', 'disabled')
        countrySelects.include_in.hide()
        countrySelects.exclude_from.removeProperty('disabled')
        countrySelects.exclude_from.show()
      }
    })
  }

  uniqueArray = (arrArg) => {
    return arrArg.filter((el, pos, arr)=> {
      return arr.indexOf(el) == pos
    })
  }
}